import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Alert,
  Button,
  Card,
  CardBody,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Typography
} from "@material-tailwind/react";
import React, {useContext, useEffect, useState} from "react";
import "../../style/datePicker.css"
import {getAgentServiceDocumentation, updateServiceFinish, updateServiceStatus} from "../../services/service/service";
import {ServiceDocumentGrid} from "./agent_service_document-grid";
import {BsBoxArrowDownRight} from "react-icons/bs";
import {ServiceDetailForm} from "./service_detail_form";
import {ServiceContext} from "./service_context";
import {submitServiceVoip} from "../../services/voip/voip";

export function AgentServiceCheckForm() {

  const {
    service,
    modalOpen,
    setModalOpen,
    lastDataRefresh,
    setLastDataRefresh,
    setStep,
  } = useContext(ServiceContext);

  const handleOpen = () => setModalOpen(!modalOpen);

  const [show, setShow] = useState(1);
  const [allAccepted, setAllAccepted] = useState(false);

  const [serviceDocumentations, setServiceDocumentations] = useState([])

  useEffect(() => {
    async function getData() {
      const result = await getAgentServiceDocumentation(service.id);
      if (result.status === 200) {
        const {serviceDocumentationList} = result.data;
        setServiceDocumentations(serviceDocumentationList || []);
        if (serviceDocumentationList?.length > 0) {
          const all_accepted = serviceDocumentationList.every(obj => obj.status === "accepted")
          setAllAccepted(all_accepted);

        } else {
          setAllAccepted(true);
        }
      }
    }

    getData()
  }, [lastDataRefresh]);

  const save = async () => {
    const data = {
      id: service.id,
      status: "waiting",
    };
    let result;

    result = await updateServiceStatus(data);

    if (result.status === 202) {
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  const save_finish = async () => {

    let result;

    result = await updateServiceFinish(service.id);

    if (result.status === 202) {
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  const handleShow = (value) => {
    setShow(show === value ? 0 : value);
  }

  return (<>
    <Dialog size="xl" open={modalOpen} handler={handleOpen}
            animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
            className="max-h-screen overflow-y-scroll mt-20">
      <DialogHeader className="border-b">
        <Typography>
          {"درخواست خدمات" + " - " + service.person_name + " " + service.person_family + " - " + service.field_title + " " + service.branch_title}
        </Typography>
      </DialogHeader>
      <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

        <Alert className="mt-8 w-full px-0" variant="gradient">
          <Typography variant="h5" className="mb-4">
            مشاور گرامی، لطفا قبل از هر گونه اقدام نکات زیر را مطالعه نمائید؛
          </Typography>
          <Typography variant="body" color="">
            <li>
              لطفا در ارائه قیمت و زمان انجام فرآیند خدمت دقت کافی و لازم را بعمل آورید، هر گونه اشتباه
              در قیمت گذاری خدمات و تاخیر در تعداد روز انجام خدمت مشمول جریمه و خسارت به کاربر متقاضی خدمت
              خواهد بود.
            </li>
          </Typography>
          <Typography variant="body" color="">
            <li>
              دکمه تائید پرداخت پس از بررسی مدارک و تائید مدارک ارسالی از سوی متقاضی، توسط شما فعال
              خواهد شد.
            </li>
          </Typography>
          <Typography variant="body" color="">
            <li>
              اگر برای قیمت گذاری بهتر نیاز به تماس با کاربر را دارید، با کلیک بر روی دکمه تماس با
              کاربر، تماس فی مابین بصورت خودکار برقرار خواهد شد.
            </li>
          </Typography>
          <Typography variant="body" color="">
            <li>
              در صورت نیاز به مدارک و مستندات بیشتر می توانید با کلیک بر روی دکمه جدید درخواست مدارک
              بیشتری نمائید.
            </li>
          </Typography>
        </Alert>

        <Button
          variant="outlined"
          className="justify-start textCenter max-w-[120px]"
          onClick={() => {
            const data = {service_id: service.id,};
            submitServiceVoip(data);
          }}
        >
          تماس با کاربر
        </Button>

        <Card>
          <CardBody className="flex flex-col">

            <Accordion open={show === 1} className="mb-4">
              <AccordionHeader
                className="flex flex-row justify-between px-2 border bg-blue-gray-50 rounded-t-2xl hover:bg-blue-50"
                onClick={() => handleShow(1)}>
                <Typography className="flex w-full font-bold text-lg">
                  مدارک مورد نیاز
                </Typography>
                <BsBoxArrowDownRight className="flex"/>
              </AccordionHeader>

              <AccordionBody>
                <div className="flex flex-row justify-end">
                  {service.status !== "finish" &&
                    <Button className="w-1/12" onClick={() => {
                      setStep("documentation");
                    }} variant="outlined">
                      جدید
                    </Button>
                  }
                </div>
                <ServiceDocumentGrid setAllAccepted={setAllAccepted}
                                     serviceDocuments={serviceDocumentations}
                />
              </AccordionBody>

            </Accordion>

            <Accordion open={show === 2} className="mb-4">
              <AccordionHeader
                className="flex flex-row justify-between px-2 border bg-blue-gray-50 rounded-t-2xl hover:bg-blue-50"
                onClick={() => handleShow(2)}>
                <Typography className="flex w-full font-bold text-lg">
                  قیمت گذاری و اطلاعات خدمات
                </Typography>
                <BsBoxArrowDownRight className="flex"/>
              </AccordionHeader>

              <AccordionBody>
                <ServiceDetailForm/>
              </AccordionBody>

            </Accordion>
          </CardBody>
        </Card>

      </DialogBody>

      {service.status !== "finish" &&
        <DialogFooter className="space-x-2 mb-4">
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>بستن</span>
          </Button>
          {service.price && service.price > 0 && service.day > 0 && allAccepted && service.status !== "payment" &&
            <Button variant="gradient" color="gray" onClick={save} className="ml-1">
              <span>تایید جهت پرداخت</span>
            </Button>
          }
          {service.price && service.price > 0 && service.day > 0 && allAccepted === false && service.status !== "payment" &&
            <Button variant="gradient" color="gray" onClick={save} className="ml-1" disabled={true}>
              <span>در انتظار بررسی مدارک</span>
            </Button>
          }
          {service.price && service.price > 0 && service.day > 0 && allAccepted && service.status === "payment" &&
            <Button variant="gradient" color="gray" onClick={save_finish} className="ml-1">
              <span>اتمام خدمات</span>
            </Button>}
        </DialogFooter>}
    </Dialog>
  </>);
}